import React from "react";
import { connect } from "react-redux";
import BatchProcessingHistory from "../../../components/BatchProcessingHistory";
import { batchProcessingConfigs } from "../../../components/BatchProcessingHistory/configs";

const BulkTransactionUploadHistory = (props) => {
  return (
    <BatchProcessingHistory
      {...props}
      config={batchProcessingConfigs.batchProcessingBulkTransactionUpload}
    />
  );
};

const mapState = ({ transactionReportUploadsList, session }) => {
  return {
    transactionReportUploadsList:
      transactionReportUploadsList?.transactionReportUploadsList || [],
    totalItems: transactionReportUploadsList?.totalItems || 0,
    user: session.user,
    fetching: transactionReportUploadsList?.fetching || false,
    fetched: transactionReportUploadsList?.fetched || false,
  };
};

export default connect(mapState)(BulkTransactionUploadHistory);
